import { PositiveFill, NegativeFillDiamond } from 'ui/icons/status';
import { PlatformAndroid16, PlatformApple16 } from 'ui/icons/aurora/16px';
import { Accordion, AccordionContent, AccordionHeader } from 'ui/accordion';
import { FlexSpacer } from 'ui/flexSpacer';
import { colors } from 'ui/theme/colors';
import { BoldText } from 'ui/theme/typography';
import { LegacyDomainLabel } from './LegacyDomainLabel';
import { AppSiteAssociations } from '../types';

type DeepLinksAccordionProps = {
  assetLinksExist?: boolean;
  deepLinks?: AppSiteAssociations[];
};

export const DeepLinksAccordion = ({
  assetLinksExist = false,
  deepLinks = [],
}: DeepLinksAccordionProps) => {
  return !deepLinks.length ? null : (
    <Accordion style={{ backgroundColor: 'transparent', padding: 0 }}>
      <AccordionHeader>
        {deepLinks.length === 1
          ? '1 destination domain'
          : `${deepLinks.length} destination domains`}
      </AccordionHeader>
      <AccordionContent>
        <FlexSpacer flexDirection="column" alignItems="flex-start">
          {deepLinks.map(({ domain, appDomain, enabledForProject }) => {
            const key = `${domain}-${appDomain}`;

            return (
              <div key={key} data-test="deep-link-domain">
                <FlexSpacer>
                  {enabledForProject ? (
                    <PositiveFill color={colors.green100} />
                  ) : (
                    <NegativeFillDiamond color={colors.iconSubtle} />
                  )}
                  <BoldText>{appDomain || domain}</BoldText>
                  <FlexSpacer gap="quarter">
                    <PlatformApple16 />
                    {assetLinksExist && <PlatformAndroid16 data-test="android-icon" />}
                  </FlexSpacer>
                  {!appDomain && <LegacyDomainLabel />}
                </FlexSpacer>
              </div>
            );
          })}
        </FlexSpacer>
      </AccordionContent>
    </Accordion>
  );
};
